import React from 'react'
import styled from 'styled-components'

const ErrorMessage = ({ error }) => <Wrapper>
  {error}
</Wrapper>

const Wrapper = styled.div`
  vertical-align: middle;
  font-size: 12px;
  color: #C7053F;
`

export default ErrorMessage
